var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"400"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-card',{attrs:{"loading":_vm.value}},[_c('v-card-text',{staticClass:"mt24"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }